import * as Yup from 'yup';
import { _t } from 'app/utils/i18n';
export const schema = Yup.object().shape({
  description: Yup.string()
    .required(_t('basic:This_field_is_mandatory'))
    .min(
      2,
      _t('basic:err_min', {
        fieldName: _t('basic:description'),
        length: 2,
      })
    ),
  url: Yup.string()
    .url(_t('basic:correct_url'))
    .typeError(_t('basic:err_required')),
});
